import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  home_hero_image_url: "",
  home_hero_eyebrow: "Mixed media · Acrylic · Collage",
  home_hero_tagline: "Studio of Jewel Mason",
  home_hero_description: "",
  about_image_url: "",
  about_intro_name: "Jewel",
  about_paragraphs: [],
  about_based_in: "A quiet studio",
  about_working_in: "Mixed Media",
  contact_intro: "",
  contact_email: "",
  contact_instagram: "",
  notify_email: "",
  commission_intro: "",
  commission_process_steps: [],
  commission_prices: [],
  commission_price_note: "",
  shop_enabled: true,
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/settings");
      setSettings({ ...FALLBACK, ...res.data });
    } catch (e) {
      // Non-blocking: fall back to defaults so the page still renders
      console.warn("Failed to load site settings, using defaults:", e?.message || e);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, loaded, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
